export default __webpack_public_path__ + "static/election2-2425e0d74646f1572ce98b45bedfa3dd.png";